import { render, staticRenderFns } from "./PopupDuplicate.vue?vue&type=template&id=231753b8&scoped=true&"
import script from "./PopupDuplicate.vue?vue&type=script&lang=js&"
export * from "./PopupDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./PopupDuplicate.vue?vue&type=style&index=0&id=231753b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231753b8",
  null
  
)

export default component.exports